import r from "../managers/braze-instance.js";
import vt from "./utils/push-utils.js";
export function isPushSupported() {
  if (r.rr()) return vt.isPushSupported();
}
